import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'
import { Button } from './button'
import { Input } from './input'

export function InputGroup({ className, ...props }: ComponentProps<'div'>) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: Groups an input with its inline actions, not a set of fields.
    <div
      role="group"
      data-slot="input-group"
      className={cn(
        'group/input-group flex min-h-12 w-full min-w-0 items-center rounded-lg border border-input bg-foreground/3 has-[[aria-invalid=true]]:border-destructive has-[[data-slot=input-group-control]:focus-visible]:outline-2 has-[[data-slot=input-group-control]:focus-visible]:outline-offset-2 has-[[data-slot=input-group-control]:focus-visible]:outline-ring has-[[data-slot=input-group-control]:focus]:border-ring has-[[data-slot=input-group-control][aria-invalid=true]:focus]:border-destructive has-[[data-slot=input-group-control][aria-invalid=true]:focus-visible]:outline-destructive',
        className,
      )}
      {...props}
    />
  )
}

export function InputGroupAddon({
  className,
  align = 'inline-start',
  ...props
}: ComponentProps<'div'> & { align?: 'inline-start' | 'inline-end' }) {
  return (
    <div
      data-slot="input-group-addon"
      data-align={align}
      className={cn(
        'flex shrink-0 items-center px-1 data-[align=inline-start]:order-first data-[align=inline-end]:order-last',
        className,
      )}
      {...props}
    />
  )
}

export function InputGroupInput({ className, ...props }: ComponentProps<'input'>) {
  return (
    <Input
      data-slot="input-group-control"
      className={cn(
        'flex-1 rounded-none border-0 bg-transparent focus-visible:outline-none',
        className,
      )}
      {...props}
    />
  )
}

export function InputGroupButton({
  type = 'button',
  variant = 'ghost',
  size = 'icon',
  ...props
}: ComponentProps<typeof Button>) {
  return (
    <Button data-slot="input-group-button" type={type} variant={variant} size={size} {...props} />
  )
}
